export const Article = {
	articles: [],
	article: null,
	totalArticles: 0
};
